import { render } from "./DetailProgressReport.vue?vue&type=template&id=d38a8bb8"
import script from "./DetailProgressReport.vue?vue&type=script&lang=js"
export * from "./DetailProgressReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__